import styled from "styled-components"

import {spacingCss, SpacingProps} from "@irati/ui/src/global/css"

interface StyledProps extends SpacingProps {
  bgColor?: string
  textColor?: string
  fillColor?: string
}

const StyledChip = styled.div<StyledProps>`
  ${({theme, bgColor, textColor, fillColor}) => `
  border: 1px solid ${theme.colors.greys.medium};
  background-color: ${bgColor || theme.colors.greys.white};
  padding: ${theme.spacing.one};
  border-radius: 6px;
  cursor: default;
  font-family: ${theme.font.bold};
  line-height: 16px;
  font-size: 14px;
  color: ${textColor || theme.colors.primary2};
  path {
    fill: ${fillColor || theme.colors.greys.white}
  }
  ${spacingCss}
  `}
`

export default StyledChip
